import * as Observe from 'src/state/lib/observe';

export const BillingUrl = Observe.Value('');
export const CheckoutUrl = Observe.Value('');
export const CheckoutWebViewCurrentUrl = Observe.Value<null | string>(null);
